import { combineReducers } from 'redux';
import UpdateER from './index';

const UpdateExchangeRatesReducer = combineReducers({
  UpdateER,
});

export default UpdateExchangeRatesReducer;
